import { React, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AdminHeader from "./AdminHeader";
import Sidebar from "./Sidebar";
import { FileUploader } from "react-drag-drop-files";
import { FiUploadCloud } from "react-icons/fi";
import Upload from "./../Images/upload.png";
import { useSelector } from "react-redux";
import { updateUser, uploadDoc } from "../Services/api";
import { toast } from "react-toastify";
import * as Yup from "yup";
import CustomToast from "../Components/CustomToast/CustomToast";

const fileTypes = ["JPG", "PNG", "JPEG"];
function EditUserVerify() {
  const navigate = useNavigate();

  const { createUserData } = useSelector((store) => store.dataReducer);
  const [filePan, setFile] = useState(null);

  const [fileAadhar, setFile1] = useState(null);
  const [img, setImg] = useState(null);
  const [img1, setImg1] = useState(null);
  const handleChange = (filePan) => {
    setFile(filePan);
    setImg(URL.createObjectURL(filePan[0]));
  };
  const handleChange1 = (fileAadhar) => {
    setFile1(fileAadhar);
    setImg1(URL.createObjectURL(fileAadhar[0]));
  };

  const [isOpen, setOpen] = useState(false);
  // const [isClose, setClose] = useState(false);
  const toggleOpen = () => {
    setOpen(!isOpen);
  };

  const doSubmitDoc = async (event) => {
    try {
      event.preventDefault();
      const formDataPan = new FormData();
      const formDataAdhar = new FormData();
      for (const key of filePan) {
        formDataPan.append("file", key);
      }
      for (const key of fileAadhar) {
        formDataAdhar.append("file", key);
      }
      const respPan = await uploadDoc(formDataPan);
      const respAdhar = await uploadDoc(formDataAdhar);

      const request = {
        ...createUserData,
        aadharCardUrl: respAdhar.data,
        panCardUrl: respPan.data,
      };
      const resp = await updateUser(request);

      toast(<CustomToast type="success" message={resp.msg} />, {
        autoClose: 3000,
      });
      navigate("/userlist");
    } catch (error) {
      toast(<CustomToast type="error" message={error} />, {
        autoClose: 3000,
      });
    }
  };

  const stack2 = (
    <div className="drop-layout d-flex flex-column align-items-center justify-content-center">
      <div className="box box-1 h-100 text-center ">
        <div className="drop-img">
          <img src={Upload} alt="" />
        </div>
        <div className="drop-text">
          <h2>Drop Your Pan Card</h2>
          <p>(Minimal size 1660 x 960px )</p>
        </div>
        <div className="drop-btn ">
          <Link to="">select file</Link>
        </div>
      </div>
    </div>
  );
  const stack3 = (
    <div className="drop-layout d-flex flex-column align-items-center justify-content-center">
      <div className="box box-1 h-100 text-center ">
        <div className="drop-img">
          <img src={Upload} alt="" />
        </div>
        <div className="drop-text">
          <h2>Drop Your Aadhar Card</h2>
          <p>(Minimal size 250mb )</p>
        </div>
        <div className="drop-btn ">
          <Link to="">select file</Link>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div className="dashboard">
        <div className={isOpen ? "d-flex toggled" : "d-flex"} id="wrapper">
          <Sidebar />
          <div className="page-content">
            <nav className="navbar navbar-expand-lg navbar-light bg-transparent">
              <div className="d-flex align-items-center py-3 ps-3  d-lg-none">
                <Link onClick={toggleOpen} role="button">
                  <i
                    className="fas fa-align-left primary-text fs-4 me-3"
                    id="menu-toggle"
                  ></i>
                </Link>
              </div>
              <AdminHeader />
            </nav>
            {/* <!-- Areas --> */}
            <div className="dashboard-page p-4">
              {/* contact form starts*/}
              <div className="contact dashboard-form">
                <div className="container">
                  <div className="upload-sub-head text-center mb-5">
                    <h4>Upload Adhaar card and pan card photo*</h4>
                  </div>
                  <div className="contact-area">
                    <form action="">
                      <div className="contact-form row">
                        <div className="mb-4 col-lg-6">
                          <FileUploader
                            children={stack2}
                            multiple={true}
                            handleChange={handleChange}
                            name="filePan"
                            types={fileTypes}
                          />
                          <div className="text-center">
                            <div className="contact-sub-head mt-3 mb-2">
                              <h4>Image Preview</h4>

                            </div>
                            <img className='upload-i' src={img} />
                            <p className="file-select">

                              {filePan ? `File name: ${filePan[0].name}` : ""}
                            </p>
                          </div>
                        </div>

                        <div className="mb-4 col-lg-6">
                          <FileUploader
                            children={stack3}
                            multiple={true}
                            handleChange={handleChange1}
                            name="fileAadhar"
                            types={fileTypes}
                          />
                          <div className="text-center">
                            <div className="contact-sub-head mt-3 mb-2">
                              <h4>Image Preview</h4>

                            </div>
                            <img className='upload-i' src={img1} />
                            <p className="file-select">
                              {fileAadhar
                                ? `File name: ${fileAadhar[0].name}`
                                : ""}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="next-button text-end">
                        <Link className="back-btn" to="/add-user">
                          Back
                        </Link>
                        <button
                          onClick={(event) => {
                            doSubmitDoc(event);
                          }}
                        >
                          Save
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              {/* contact form ends */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditUserVerify;
